<div class="ktbl-spacer-top-bottom"></div>

<div class="ktbl-container">
  <!-- mat-align-tabs="start" -->
  <mat-tab-group [(selectedIndex)]="selectedTabIndex" mat-align-tabs="start" dynamicHeight="true"
    animationDuration="0ms" (focusChange)="beforeTabChange()">

    <mat-tab label="Auswahl">
      <app-auswahl></app-auswahl>
    </mat-tab>

    <mat-tab label="Vergleich">
      <app-ergebnisse *ngIf="selectedTabIndex === 1"></app-ergebnisse>
    </mat-tab>

    <mat-tab label="Einstellungen">
      <app-einstellungen
        *ngIf="selectedTabIndex === 2 || localService.einstellungenComponentRef.value?.isDataChanged"></app-einstellungen>
    </mat-tab>
  </mat-tab-group>


  <div class="ktbl-floating-container-ohne-rand">
    <div class="ktbl-floating-content">
      <button (click)="onClickZuErgebnisse()" *ngIf="selectedTabIndex === 0" mat-raised-button
        class="ktbl-button-primaer ktbl-button-icon-l" type="button" matTooltip="Zum Vergleich"
        [matTooltipPosition]="position.value" [matTooltipClass]="position.value">
        <i class="fas fa-arrow-right ktbl-icon-vertical-align"></i>

      </button>

      <button (click)="onClickZurAuswahl()" *ngIf="selectedTabIndex === 1" mat-raised-button
        class="ktbl-button-primaer ktbl-button-icon-l" type="button" matTooltip="Zurück"
        [matTooltipPosition]="position.value" [matTooltipClass]="position.value">
        <i class="fas fa-arrow-left ktbl-icon-vertical-align"></i>

      </button>

      <button (click)="this.localService.ergebnisseComponentRef.value!.onClickDownloadExcel()"
        *ngIf="selectedTabIndex === 1 && this.localService.selectedGebaeudeList.value.length !== 0" mat-raised-button
        class="ktbl-button-primaer ktbl-button-icon-l" type="button" matTooltip="Export"
        [matTooltipPosition]="position.value" [matTooltipClass]="position.value">
        <i class="fas fa-download ktbl-icon-vertical-align"></i>

      </button>

      <button (click)="onClickUp()" mat-raised-button class="ktbl-button-primaer ktbl-button-icon-l" type="button">
        <i class="fas fa-chevron-up ktbl-icon-vertical-align"></i>

      </button>


      <button (click)="onClickDown()" mat-raised-button class="ktbl-button-primaer ktbl-button-icon-l" type="button">
        <i class="fas fa-chevron-down ktbl-icon-vertical-align"></i>

      </button>
    </div>
  </div>




</div>

<div class="ktbl-spacer-top-bottom"></div>